import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import { usePageEventDispatcher } from "@octopusdeploy/portal-routes";
import { Action } from "~/analytics/Analytics";
import { createActionTypeField, createProjectIdField, createResourceTypeField, createStringField } from "~/analytics/fields";

export function useNotifyViewTaskLog(projectId?: string) {
    const dispatcher = usePageEventDispatcher();
    const session = useAnalyticSession();
    const anonymizedProjectId = projectId === undefined ? undefined : session.anonymize(projectId);

    return (deploymentStatus?: string) => {
        dispatcher("View Task Log", {
            ...createResourceTypeField("Task Log"),
            ...createActionTypeField(Action.View),
            ...createStringField("Deployment Status", deploymentStatus),
            ...createProjectIdField(anonymizedProjectId),
        });
    };
}

export function useNotifyTaskLogVerboseToggle(projectId?: string) {
    const dispatcher = usePageEventDispatcher();
    const session = useAnalyticSession();
    const anonymizedProjectId = projectId === undefined ? undefined : session.anonymize(projectId);

    return (enabled: boolean, deploymentStatus?: string) => {
        const eventName = enabled ? "Task Log: Enabled Verbose" : "Task Log: Disabled Verbose";
        dispatcher(eventName, {
            ...createResourceTypeField("Task Log"),
            ...createActionTypeField(Action.Toggle),
            ...createStringField("Deployment Status", deploymentStatus),
            ...createProjectIdField(anonymizedProjectId),
        });
    };
}

export function useNotifyTaskLogTimestampsToggle(projectId?: string) {
    const dispatcher = usePageEventDispatcher();
    const session = useAnalyticSession();
    const anonymizedProjectId = projectId === undefined ? undefined : session.anonymize(projectId);

    return (enabled: boolean, deploymentStatus?: string) => {
        const eventName = enabled ? "Task Log: Enabled Timestamps and Categories" : "Task Log: Disabled Timestamps and Categories";
        dispatcher(eventName, {
            ...createResourceTypeField("Task Log"),
            ...createActionTypeField(Action.Toggle),
            ...createStringField("Deployment Status", deploymentStatus),
            ...createProjectIdField(anonymizedProjectId),
        });
    };
}

export function useNotifyTaskLogExpandCollapseSelection(projectId?: string) {
    const dispatcher = usePageEventDispatcher();
    const session = useAnalyticSession();
    const anonymizedProjectId = projectId === undefined ? undefined : session.anonymize(projectId);

    return (selectedOption: string, deploymentStatus?: string) => {
        dispatcher("Task Log: Selected Expand/Collapse option", {
            ...createResourceTypeField("Task Log"),
            ...createActionTypeField(Action.Select),
            ...createStringField("Selected Option", selectedOption),
            ...createStringField("Deployment Status", deploymentStatus),
            ...createProjectIdField(anonymizedProjectId),
        });
    };
}

export function useNotifyTaskLogRawLogClick(projectId?: string) {
    const dispatcher = usePageEventDispatcher();
    const session = useAnalyticSession();
    const anonymizedProjectId = projectId === undefined ? undefined : session.anonymize(projectId);

    return (deploymentStatus?: string) => {
        dispatcher("Task Log: Viewed Raw Log", {
            ...createResourceTypeField("Task Log"),
            ...createActionTypeField(Action.View),
            ...createStringField("Deployment Status", deploymentStatus),
            ...createProjectIdField(anonymizedProjectId),
        });
    };
}

export function useNotifyTaskLogDownloadClick(projectId?: string) {
    const dispatcher = usePageEventDispatcher();
    const session = useAnalyticSession();
    const anonymizedProjectId = projectId === undefined ? undefined : session.anonymize(projectId);

    return (deploymentStatus?: string) => {
        dispatcher("Task Log: Downloaded Raw Log", {
            ...createResourceTypeField("Task Log"),
            ...createActionTypeField(Action.Download),
            ...createStringField("Deployment Status", deploymentStatus),
            ...createProjectIdField(anonymizedProjectId),
        });
    };
}
